module.exports = __webpack_public_path__ + "static/media/handshake-inactive.1a01d986.svg";